export default __webpack_public_path__ + "assets/m2.5f8ad730.png";